import { InjectionToken, Provider } from '@angular/core';
import { ActionReducer, ActionReducerMap } from '@ngrx/store';
import { CustomSearchResults } from '@search/const';
import { StateUtils } from '@spartacus/core';
import { SearchActions } from '../actions';
import { FACETS_TOTAL_RESULTS, SEARCH_SUGGESTIONS, SearchState } from '../search-state';
import { reducer as activeFacetsReducer } from './active-facets.reducer';
import { reducer as searchHistoryReducer } from './search-history.reducer';
import { reducer as selectedFacetsReducer } from './selected-facets.reducer';

export type SearchReducers = SearchState;

export function getReducers(): ActionReducerMap<SearchReducers> {
  return {
    totalResults: StateUtils.loaderReducer(FACETS_TOTAL_RESULTS),
    activeFacets: activeFacetsReducer,
    selectedFacets: selectedFacetsReducer,
    searchSuggestions: StateUtils.loaderReducer<CustomSearchResults>(SEARCH_SUGGESTIONS),
    searchHistory: searchHistoryReducer,
  };
}

export function clearSelectedFacetsMetaReducer(reducer: ActionReducer<SearchReducers>): ActionReducer<SearchReducers> {
  return (state, action) => {
    let nextState = reducer(state, action);

    if (action.type === SearchActions.CLEAR_SELECTED_FACETS) {
      nextState = {
        ...nextState,
        selectedFacets: nextState.activeFacets,
      };
    }

    return nextState;
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<SearchReducers>> = new InjectionToken<
  ActionReducerMap<SearchReducers>
>('SearchReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
